





























import { Component, PropSync, Prop, Vue } from "vue-property-decorator";
import store from "@/store";
//  @types
import { ILongTrendPeriod } from "@/types/longTrendPeriod";
//  @components
import StatisticsCard from "@/components/diagnosticsDetails/StatisticsCard.vue";
import LimitsCard from "@/components/diagnosticsDetails/LimitsCard.vue";
//  @modules
import { getModule } from "vuex-module-decorators";
import LongTrendPeriodModule from "@/store/clients/LongTrendPeriod.module";

const LongTrendPeriod = getModule(LongTrendPeriodModule, store);

@Component({
  components: {
    StatisticsCard,
    LimitsCard,
  },
})
export default class VesselEventModal extends Vue {
  @PropSync("value", { required: true, type: Boolean, default: false }) isModalActive!: boolean;
  @Prop({ type: String, default: "450px" }) width!: string;

  //  @Data

  //  @Getters
  get longTrendPeriod(): ILongTrendPeriod | null {
    return LongTrendPeriod.longTrendPeriod;
  }

  get isCloudCalculated(): boolean | undefined {
    return this.longTrendPeriod?.isCloudCalculated;
  }

  //  @Methods
  open(): void {
    this.isModalActive = true;
  }

  close(): void {
    this.isModalActive = false;
  }
}
